import React from 'react';
import { removeHost } from "../../utils/functions";
import { Link } from 'gatsby';
import { CategoriesListDataPL } from './CategoriesListHookPL';
import { CategoriesListDataDE } from './CategoriesListHookDE';
import { CategoriesListDataEN } from './CategoriesListHookEN';
import { v4 as uuid } from 'uuid';


const CategoriesList = ({ breadcrumbs, heading, lang }) => {
  let data = []
  if (lang === 'pl') {
    data = CategoriesListDataPL();
  }
  if (lang === 'de') {
    data = CategoriesListDataDE();
  }
  if (lang === 'en') {
    data = CategoriesListDataEN();
  }
  return (<div className="categoriesList">
    <h3 className="heading--small">{heading}</h3>
    <ul className="categoriesList__list">
      {data.nodes.map(firstLevelItem => (
        firstLevelItem.parent ? '' : (
          // {
          breadcrumbs?.length >= 3 ? (
            <li key={uuid()} className={`categoriesList__item ${breadcrumbs.length === 3 && firstLevelItem.name === breadcrumbs[2].breadcrumb.title ? 'categoriesList__item--active' : ''} ${firstLevelItem.name === breadcrumbs[2].breadcrumb.title ? 'categoriesList__item--open' : ''}`}>
              <Link to={removeHost(firstLevelItem.uri)}>{firstLevelItem.name}</Link>
              {firstLevelItem.children.nodes.length ? (
                <>
                  <span className="categoriesList__item__arrow" onClick={() => { }}></span>
                  <ul className="categoriesList__list">
                    {firstLevelItem.children.nodes.map(secondLevelItem => {
                      return (
                        <li key={uuid()} className={`categoriesList__item ${breadcrumbs.length === 4 ? (secondLevelItem.name === breadcrumbs[3].breadcrumb.title ? 'categoriesList__item--active' : '') : ''} ${breadcrumbs.length >= 4 ? (secondLevelItem.name === breadcrumbs[3].breadcrumb.title ? 'categoriesList__item--open' : '') : ''}`}>
                          <Link to={removeHost(secondLevelItem.uri)}>{secondLevelItem.name}</Link>
                          {secondLevelItem.children.nodes.length ? (
                            <>
                              <span className="categoriesList__item__arrow"></span>
                              <ul className="categoriesList__list">
                                {secondLevelItem.children.nodes.map(thirdLevelItem => (
                                  <li key={uuid()} className={`categoriesList__item ${breadcrumbs.length === 5 ? (thirdLevelItem.name === breadcrumbs[4].breadcrumb.title ? 'categoriesList__item--active' : '') : ''}`}>
                                    <Link to={removeHost(thirdLevelItem.uri)}>{thirdLevelItem.name}</Link>
                                  </li>
                                ))}
                              </ul>
                            </>
                          ) : ''}
                        </li>
                      )
                    })}
                  </ul>
                </>
              ) : ''}
            </li>
          ) : (
            <li key={uuid()} className={`categoriesList__item `}>
              <Link to={removeHost(firstLevelItem.uri)}>{firstLevelItem.name}</Link>
              {firstLevelItem.children.nodes.length ? (
                <>
                  <span className="categoriesList__item__arrow" onClick={() => { }}></span>
                  <ul className="categoriesList__list">
                    {firstLevelItem.children.nodes.map(secondLevelItem => {
                      return (
                        <li key={uuid()} className={`categoriesList__item ${breadcrumbs.length === 4 ? (secondLevelItem.name === breadcrumbs[3].breadcrumb.title ? 'categoriesList__item--active' : '') : ''} ${breadcrumbs.length >= 4 ? (secondLevelItem.name === breadcrumbs[3].breadcrumb.title ? 'categoriesList__item--open' : '') : ''}`}>
                          <Link to={removeHost(secondLevelItem.uri)}>{secondLevelItem.name}</Link>
                          {secondLevelItem.children.nodes.length ? (
                            <>
                              <span className="categoriesList__item__arrow"></span>
                              <ul className="categoriesList__list">
                                {secondLevelItem.children.nodes.map(thirdLevelItem => (
                                  <li key={uuid()} className={`categoriesList__item ${breadcrumbs.length === 5 ? (thirdLevelItem.name === breadcrumbs[4].breadcrumb.title ? 'categoriesList__item--active' : '') : ''}`}>
                                    <Link to={removeHost(thirdLevelItem.uri)}>{thirdLevelItem.name}</Link>
                                  </li>
                                ))}
                              </ul>
                            </>
                          ) : ''}
                        </li>
                      )
                    })}
                  </ul>
                </>
              ) : ''}
            </li>
          )
          // }
        )
      ))}
    </ul>
  </div >)
}
export default CategoriesList
